<router-outlet></router-outlet>
<p-toast position="top-right"></p-toast>
<p-confirmDialog [header]="'alerts.confirmTitle' | translate" icon="pi pi-exclamation-triangle"> </p-confirmDialog>
<ngx-loading-bar color="#ef3e5c"></ngx-loading-bar>
<app-chatbot-ui *ngIf="authService.isUserAuthenticated()" [showChatBot]="true"></app-chatbot-ui>
